// Hledání v chatech (Ctrl+K), Spotlight z UI kitu.
import { useMemo, useState } from 'react';
import { ChatCircleIcon, HouseIcon } from '@phosphor-icons/react';
import { Spotlight, type SpotlightItem } from '@smworks-cz/ui-kit';
import { useConversations } from '../lib/queries';
import { chatPath, navigate } from '../lib/router';

const norm = (s: string) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export function Search({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [q, setQ] = useState('');
  const { data } = useConversations();
  const results = useMemo<SpotlightItem[]>(() => {
    const n = norm(q.trim());
    const go = (to: string) => () => {
      navigate(to);
      onClose();
      setQ('');
    };
    const items: SpotlightItem[] = [{ id: 'home', label: 'Nový chat', category: 'Stránky', icon: <HouseIcon size={16} />, onSelect: go('/') }];
    for (const c of data ?? []) {
      items.push({ id: c.id, label: c.title, category: 'Chaty', icon: <ChatCircleIcon size={16} />, onSelect: go(chatPath(c.id)) });
    }
    return items.filter((i) => !n || norm(i.label).includes(n)).slice(0, 20);
  }, [q, data, onClose]);
  return <Spotlight open={open} onClose={onClose} value={q} onChange={setQ} results={results} placeholder="Hledat chaty…" />;
}
